// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"C3-z","colorTextValue":"D3-z","swatches":"E3-z","collapseLink":"F3-z","isCollapsed":"G3-z","dropdown":"H3-z","disabled":"I3-z"};